import { message as antdMessage } from 'src/antd';
import React from 'react';
import { T } from '@transifex/react';

type TAPIErrorOpts = {
  ERROR_MESSAGE_HANDLED?: boolean;
  /**
   * The parsed response body, for the callers that need more than the message.
   * The portal's rate limiter answers 400 but still tells you *when* you may
   * retry, and dropping that left the citizen with a toast and no idea how long
   * to wait (PRO-635).
   */
  data?: Record<string, unknown>;
};

const handleError = (e: unknown) => {
  const error: APIError = e as APIError;
  if (!error.opts?.ERROR_MESSAGE_HANDLED)
    antdMessage.error(<T _str="Error occured" />);
};

export class APIError extends Error {
  opts?: TAPIErrorOpts = {};

  constructor(message: string, opts?: TAPIErrorOpts) {
    super(message); // (1)
    this.name = 'APIError'; // (2)
    this.opts = opts;
  }
}

export const apiErrorUtils = { handleError };
